module.exports = __webpack_public_path__ + "images/external_images/img/425x457/img1.jpg";